
import { EmailBrandingTabList } from '@/entities/OrganizationalSettings/EmailBrandingTabList';
import EmailBrandingListings from './EmailBrandingListings.vue';
import { TabViewModel } from '@/entities/TabViewModel';
import { Component, toNative, Vue } from 'vue-facing-decorator';
import VueTabs from '@/components/Common/Tabs.vue';
import EmailBrandingDrawer from './EmailBrandingDrawer.vue';
import { FetchData, Root, Store } from '@/main';
import EmailDomainManager from './EmailDomainManager.vue';
import { EmailBrandingViewModel } from '@/entities/OrganizationalSettings/EmailBrandingViewModel';
import { EmailDomainsViewModel } from '@/entities/OrganizationalSettings/EmailDomainsViewModel';
import EmailListingsModel from '@/entities/OrganizationalSettings/EmailListingsModel';
import EmailBrandingHelper from '@/helper/EmailBrandingHelper';
import loading from '@/components/Common/loading.vue';
import Toaster from '@/components/Common/Toaster.vue';
import ModalPopup from '@/components/Common/ModalPopup.vue';
import DomainStatusTypeEnum from '@/enums/DomainStatusTypeEnum';
import { StoreHelper } from '@/store/StoreHelper';
import EmailDomainDrawerTypeEnum from '@/enums/EmailDomainDrawerTypeEnum';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
@Component({
  components: {
    VueTabs,
    EmailBrandingListings,
    EmailBrandingDrawer,
    EmailDomainManager,
    loading,
    Toaster,
    ModalPopup,
  },
})
class EmailBranding extends Vue {
  private tabViewModel: EmailBrandingTabList = new EmailBrandingTabList();
  private emailBrandingTabEntityList: TabViewModel[] = this.tabViewModel.TabViewModels;
  private domainRecords = EmailDomainsViewModel.createEmpty();
  private domainGlobeIcon = require('@/assets/Images/globe-icon.svg');
  private addActionIcon = require('@/assets/Images/add-action-icon.svg');
  private deleteIcon = require('@/assets/Images/bin-icon.svg');
  private warningStatusIcon  = require('@/assets/Images/warning-status-icon.svg');
  private infoStatusIcon = require('@/assets/Images/blue-icon-icon.svg');
  private openDrawer = false;
  private isDomainTooltipVisible = false;
  private emailDomainListings: EmailBrandingViewModel[] = [];
  private selectedDrawerType = EmailBrandingHelper.DomainDrawer;
  private defaultDrawerWidth = '40%';
  private editEmailData = EmailListingsModel.createEmpty();
  private toasterDefaultTimeout = EmailBrandingHelper.ToasterTimeOut;
  private loaderDefaultTimeout = EmailBrandingHelper.LoaderTimeOut;
  private toasterMessage = '';
  private loaderBorderColor = '';
  private showLoading = false;
  private showToaster = false;
  private tooltipInfoMessage = '';
  private currentModal = EmailBrandingHelper.DeleteDomainModal;
  private domainId = -1;
  private isMobileView = false;
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private reqInfo: AppRequestInfo = this.storeHelper.GetRequestInfoFromStore();
  private learnMoreLink = 'https://support.ventla.io/kb/custom-domains/how-it-works';

  // Modal Pop up properties
  private modalPopupVisible = false;
  private modalPopupHeading = '';
  private modalPopupBodyHeading = '';
  private showCloseButton = false;
  private showCancelButton = false;
  private showConfirmButton = false;
  private modalPopupContent = '';
  private buttonText = '';
  private cancelButtonText = '';
  private imageIcon = '';

  // Computed property: Automatically updates when Store changes
  public get isPFActive(): boolean {
    const storeHelper = new StoreHelper(Store);
    const reqInfo = storeHelper.GetRequestInfoFromStore();
    // Explicit null/undefined check
    if (reqInfo !== null && reqInfo !== undefined) {
      return reqInfo.IsWhiteLabelledDomainsPFActive;
    }
    return false;
  }

  // Check Is LoggedIn User Super Admin or Application Admin
  public get isLoggedInUserSuperAdminOrAppAdmin(): boolean {
    return (!!this.storeHelper.GetRequestInfoFromStore().IsSuperAdmin || !!this.storeHelper.GetRequestInfoFromStore().IsApplicationAdmin);
  }

  // Check if Add Domain button should be shown
  public get showAddDomainButton(): boolean {
    return this.isLoggedInUserSuperAdminOrAppAdmin || this.domainRecords.Domains.length > 0;
  }

  // Getter to check if any email is inactive
  public get hasInActiveEmail(): boolean {
    return this.emailDomainListings.some((domain) => domain.DomainId !== 0 && domain.Emails.some((email) => !email.IsActive));
  }

  // Getter to calculate button state reactively
  public get isAddEmailButtonDisabled(): boolean {
    const hasNoDomain = this.domainRecords.Domains.length === 0;
    const hasValidActiveDomain = this.domainRecords.Domains.some((domain) => domain.IsValid);
    const totalEmailsCount = this.emailDomainListings.reduce((total, domain) => total + (domain.Emails ? domain.Emails.length : 0), 0);
    const hasReachedLimit = totalEmailsCount >= EmailBrandingHelper.TotalEmailsLimit;
    return (!hasNoDomain && !hasValidActiveDomain) || hasReachedLimit || this.hasInActiveEmail;
  }

  // Getter for Drawer type
  public get DrawerType(): typeof EmailDomainDrawerTypeEnum {
    return EmailDomainDrawerTypeEnum;
  }

  private mounted(){
    // Check for mobile view
    if(window.innerWidth <= 767){
      this.isMobileView = true;
    }else{
      this.isMobileView = false;
    }
    this.GetListOfEmails();
    this.GetDomianRecords();
    Root.on('close-drawer', ()=>{
      this.openDrawer = false;
      this.domainId = -1;
    });
  }

  // Show hide the information tooltip
  private GetInformationString(val: boolean) {
    if(!this.isPFActive){
      this.isDomainTooltipVisible = val;
      this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.EmailBrandingNotEnablesInfoText').toString();
      return;
    }
    if (this.hasInActiveEmail) {
      this.isDomainTooltipVisible = val;
      this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.BrokenEmailTooltip').toString();
      return;
    }
    if( this.domainRecords.Domains !== null && this.domainRecords.Domains !== undefined &&  this.domainRecords.Domains.length > 0){
      const [currentDomain] = this.domainRecords.Domains;
      const status = currentDomain.OverallDomainStatus;
      const domainCount = this.domainRecords.Domains.length;
      const totalEmailsCount = this.emailDomainListings.reduce((total, domain) => total + (domain.Emails ? domain.Emails.length : 0), 0);

      if (domainCount === 1 && status === DomainStatusTypeEnum.Pending && totalEmailsCount === 1) {
        this.isDomainTooltipVisible = val;
        this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.DomainVerificationInProgressTooltip').toString();
      }else if (domainCount === 1 && status === DomainStatusTypeEnum.Broken) {
        this.isDomainTooltipVisible = val;
        this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.BrokenRecordInfoText').toString();
      }else if (domainCount === 1 && status === DomainStatusTypeEnum.Verified && totalEmailsCount >= EmailBrandingHelper.TotalEmailsLimit) {
        this.isDomainTooltipVisible = val;
        this.tooltipInfoMessage = this.$t('OrgSettings.EmailBranding.OnlyOneEmailCanBeAddedInfoText').toString();
      } else {
        this.isDomainTooltipVisible = false;
        this.tooltipInfoMessage = '';
      }
    } else {
      this.isDomainTooltipVisible = false;
      this.tooltipInfoMessage = '';
    }
  }

  // Common function for showing and hiding toaster message and loader
  private ShowToasterAndLoader(toasterMessage: string) {
    this.toasterMessage = toasterMessage;
    this.showToaster = true;
    setTimeout(() => {
      this.showLoading = false;
      setTimeout(() => {
        this.showToaster = false;
      }, this.toasterDefaultTimeout);
    }, this.loaderDefaultTimeout);
  }

  // Fetch all email listings
  private GetListOfEmails(){
    FetchData('/CustomDomains/GetAppDomains','').then((response) => {
      this.emailDomainListings = response.data.DomainEmails;
    }).catch(()=>{
      // console error if any
    });
  }

  // Open Delete domain record modal
  private ShowConfirmationModal(domainID: number){
    const targetDomain = this.emailDomainListings.find((d) => d.DomainId === domainID);
    let isAppliedEmailInThisDomain = false;
    if(targetDomain !== null && targetDomain !== undefined){
      isAppliedEmailInThisDomain = targetDomain.Emails.some((email) => email.IsApplied);
    }
    if(isAppliedEmailInThisDomain){
      this.modalPopupVisible = true;
      this.showCancelButton = true;
      this.showCloseButton = true;
      this.showConfirmButton = false;
      this.imageIcon = this.infoStatusIcon;
      this.cancelButtonText = this.$t('Button.Close').toString();
      this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.AlertModalHeading').toString();
      this.modalPopupContent = this.$t('OrgSettings.EmailBranding.AlertModalSubHeading').toString();
    }else{
      this.domainId = domainID;
      this.currentModal = EmailBrandingHelper.DeleteDomainModal;
      this.modalPopupVisible = true;
      this.showCancelButton = true;
      this.showCloseButton = true;
      this.showConfirmButton = true;
      this.imageIcon = this.deleteIcon;
      this.cancelButtonText = this.$t('CancelButton').toString();
      this.buttonText = this.$t('DeleteButton').toString();
      this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.DeleteModalHeading').toString();
      this.modalPopupContent = this.$t('OrgSettings.EmailBranding.DeleteModalSubHeading').toString();
    }

  }

  // Function to delete a domain record
  private DeleteDomainData(){
    FetchData('/CustomDomains/DeleteDomain',JSON.stringify({
      domainSendGridId: this.domainId,
    })).then(() => {
      this.domainRecords.Domains = this.domainRecords.Domains.filter((record) => record.Id !== this.domainId);
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to fetch DNS records for the domain
  private GetDomianRecords(){
    FetchData('/CustomDomains/GetDomainsInfo', '').then((response) => {
      this.domainRecords = response.data;
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to verify the status of domain
  private VerifyDomainStatus(domainId: number, domainName: string){
    this.showLoading = true;
    FetchData('/CustomDomains/VerifyDomainAuthenticationStatus', JSON.stringify({
      domainSendGridId: domainId,
      domainName,
    })).then((response) => {
      this.showLoading = false;
      const updatedDomain = response.data;
      const selectedDomain = this.domainRecords.Domains.find((item) => item.Id === updatedDomain.Id);
      if(selectedDomain !== null && selectedDomain !== undefined){
        selectedDomain.IsValid = updatedDomain.IsValid;
        if(updatedDomain.IsValid){
          selectedDomain.OverallDomainStatus = EmailBrandingHelper.VerifiedDomain;
        }

        if((selectedDomain.DnsRecords.Spf !== null && selectedDomain.DnsRecords.Spf !== undefined) && (selectedDomain.DnsRecords.Dkim1 !== null && selectedDomain.DnsRecords.Dkim1 !== undefined) && (selectedDomain.DnsRecords.Dkim2 !== null && selectedDomain.DnsRecords.Dkim2 !== undefined) && (selectedDomain.DnsRecords.Dmarc !== null && selectedDomain.DnsRecords.Dmarc !== undefined)){
          selectedDomain.DnsRecords.Spf.IsValid = updatedDomain.DnsRecords.Spf.IsValid;
          selectedDomain.DnsRecords.Dkim1.IsValid = updatedDomain.DnsRecords.Dkim1.IsValid;
          selectedDomain.DnsRecords.Dkim2.IsValid = updatedDomain.DnsRecords.Dkim2.IsValid;
          selectedDomain.DnsRecords.Dmarc.IsValid = updatedDomain.DnsRecords.Dmarc.IsValid;
        }
      }
      if(this.emailDomainListings && this.emailDomainListings.length > 0){
        let appliedEmailDeactivated = false;
        this.emailDomainListings.forEach((email)=>{
          if(email.DomainId !== 0){
            email.Emails.forEach((emailAddress) => {
              if(emailAddress.IsApplied && !updatedDomain.IsValid){
                appliedEmailDeactivated = true;
                emailAddress.IsApplied = false;
              }
              emailAddress.IsActive = updatedDomain.IsValid;
            });
          }
        });
        if(appliedEmailDeactivated){
          const defaultDomain = this.emailDomainListings.find((d) => d.DomainId === 0);
          if(defaultDomain && defaultDomain.Emails.length > 0){
            defaultDomain.Emails[0].IsApplied = true;
          }
        }
      }
    }).catch(()=>{
      // console error if any
      this.showLoading = false;
    });
  }

  // Open Confirmation dialog for setting an email address as active email
  private OpenActivateEmailConfirmationModal(emailData: EmailListingsModel){
    this.modalPopupVisible = true;
    this.editEmailData = emailData;
    this.currentModal = EmailBrandingHelper.ActivateEmailModal;
    this.showCancelButton = true;
    this.showCloseButton = true;
    this.showConfirmButton = true;
    this.imageIcon = this.warningStatusIcon;
    this.cancelButtonText = this.$t('CancelButton').toString();
    this.buttonText = this.$t('OrgSettings.EmailBranding.Activate').toString();
    this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.ActivateEmailModalHeading').toString();
    this.modalPopupContent = this.$t('OrgSettings.EmailBranding.ActivateEmailModalSubHeading').toString();
  }

  // Open Confirmation dialog for deleting an email address
  private OpenDeleteEmailConfirmationModal(emailData: EmailListingsModel, domainId: number){
    this.modalPopupVisible = true;
    this.editEmailData = emailData;
    this.domainId = domainId;
    this.currentModal = EmailBrandingHelper.DeleteEmailAddressModal;
    this.showCancelButton = true;
    this.showCloseButton = true;
    this.showConfirmButton = true;
    this.imageIcon = this.deleteIcon;
    this.cancelButtonText = this.$t('CancelButton').toString();
    this.buttonText = this.$t('DeleteButton').toString();
    this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.DeleteEmailModalHeading').toString();
    this.modalPopupContent = this.$t('OrgSettings.EmailBranding.DeleteEmailModalSubHeading').toString();
  }

  // Functionn to set the email address as active email
  private SetEmailAsActive(emailData: EmailListingsModel){
    const toasterMessage = emailData.EmailAddress +  this.$t('OrgSettings.EmailBranding.EmailActivatedToaster').toString();
    this.showLoading = true;
    FetchData('/CustomDomains/SetActiveEmail', JSON.stringify({
      emailEntityId: emailData.EmailId,
    })).then(()=> {
      this.ShowToasterAndLoader(toasterMessage);
      this.emailDomainListings = this.emailDomainListings.map((domain) => ({
        ...domain,
        Emails: domain.Emails.map((email) => ({
          ...email,
          IsApplied: email.EmailId === emailData.EmailId,
        })),
      }));
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to delete an email address from the email listings
  private DeleteEmailAddress(emailData: EmailListingsModel, domainId: number){
    const toasterMessage = emailData.EmailAddress + this.$t('OrgSettings.EmailBranding.EmailDeletedToaster').toString();
    this.showLoading = true;
    FetchData('/CustomDomains/DeleteEmail', JSON.stringify({
      emailEntityId: emailData.EmailId,
    })).then(()=> {
      this.ShowToasterAndLoader(toasterMessage);
      this.emailDomainListings = this.emailDomainListings.map((domain) => {
        if (domain.DomainId === domainId) {
          return {
            ...domain,
            Emails: domain.Emails.filter((email) => email.EmailId !== emailData.EmailId),
          };
        }
        return domain;
      });
    }).catch(()=>{
      // console error if any
    });
  }

  // Function to show alert message
  private ShowAlertDialog(){
    this.modalPopupVisible = true;
    this.showCancelButton = true;
    this.showCloseButton = true;
    this.showConfirmButton = false;
    this.imageIcon = this.warningStatusIcon ;
    this.cancelButtonText = this.$t('Button.Close').toString();
    this.modalPopupHeading = this.$t('OrgSettings.EmailBranding.DeleteModalHeadingActiveEmail').toString();
    this.modalPopupContent = this.$t('OrgSettings.EmailBranding.DeleteModalSubHeadingActiveEmail').toString();
  }

  private ConfirmClick(confirmed: boolean) {
    if(confirmed){
      if(this.currentModal === EmailBrandingHelper.DeleteDomainModal){
        this.DeleteDomainData();
      } else if(this.currentModal === EmailBrandingHelper.DeleteEmailAddressModal){
        this.DeleteEmailAddress(this.editEmailData, this.domainId);
      } else if(this.currentModal === EmailBrandingHelper.ActivateEmailModal){
        this.SetEmailAsActive(this.editEmailData);
      }
    }
    this.modalPopupVisible = false;
  }

  // Display premium feature not enabled text
  private GetWhiteLabelText() {
    return this.$t('OrgSettings.EmailBranding.IsWhiteLabelledDomainsPFActiveText2', {
      link: `<span class="font-weight-600 font-size-14">${this.$t('OrgSettings.EmailBranding.SupportLink')}</span>`,
    });
  }

  // Open drawer to edit email address
  private EditEmailAddressInDrawer(email: EmailListingsModel, domainId: number){
    this.editEmailData = {...email};
    this.selectedDrawerType = EmailBrandingHelper.EmailDrawer;
    this.openDrawer = true;
    this.domainId = domainId;
  }

  // Handler to display add custom domain drawer
  private OpenDrawer(type: number){
    this.selectedDrawerType = type;
    if(type === 1){
      this.editEmailData = EmailListingsModel.createEmpty();
    }
    if (this.domainRecords.Domains.length > 0) {
      const [domain] = this.domainRecords.Domains;
      this.domainId = domain.Id;
    }
    this.openDrawer = true;
  }
}
export default toNative(EmailBranding);

